<div class="row salesforce-migration-header-spacer">
  <div class="col center c-info">
    <fa-icon
      [icon]="faCircleInfo"
      size="6x"
      class="u-color--extra-light"></fa-icon>
    <h2 class="u-mt--medium">
      {{ localizationConstants.SALESFORCE_MIGRATION_TITLE | translate: { appName: appName } }}
    </h2>
    <h5
      class="u-mt--medium"
      [innerHTML]="
        localizationConstants.SALESFORCE_MIGRATION_CONTACT | translate: { email: emailLink }
      "></h5>
  </div>
</div>
